import { partnerTagAPI } from '../app/axios';

export default class GssVitalSliceService {
  static async getPartnerTagIntegration(orgId) {
    if (!orgId) {
      throw new Error(
        'GssVitalSliceService.getPartnerTagIntegration: orgId undefined',
      );
    }
    const response = await partnerTagAPI.get(
      `/gss-vendor-api/integration/${orgId}`,
    );
    return response.integration;
  }

  static async setPartnerTagIntegration(orgId, data) {
    if (!orgId) {
      throw new Error(
        'GssVitalSliceService.setPartnerTagIntegration: orgId undefined',
      );
    }
    if (!data?.apiKey) {
      throw new Error(
        'GssVitalSliceService.setPartnerTagIntegration: apiKey undefined',
      );
    }
    if (!data?.storeName) {
      throw new Error(
        'GssVitalSliceService.setPartnerTagIntegration: storeName undefined',
      );
    }
    const query = {
      organization: orgId,
      apiKey: data?.apiKey,
      storeName: data?.storeName,
    };
    const response = await partnerTagAPI.patch(
      `/gss-vendor-api/integration`,
      query,
    );
    return response.results;
  }

  static async createPartnerTagIntegration(orgId, data) {
    if (!orgId) {
      throw new Error(
        'GssVitalSliceService.createPartnerTagIntegration: orgId undefined',
      );
    }
    if (!data?.apiKey) {
      throw new Error(
        'GssVitalSliceService.createPartnerTagIntegration: apiKey undefined',
      );
    }
    if (!data?.storeName) {
      throw new Error(
        'GssVitalSliceService.createPartnerTagIntegration: storeName undefined',
      );
    }
    const query = {
      organization: orgId,
      apiKey: data?.apiKey,
      storeName: data?.storeName,
    };
    const response = await partnerTagAPI.post(
      `/gss-vendor-api/integration`,
      query,
    );
    return response.results;
  }
}
